import MdField, {FIELDTYPE} from "core/metamodel/mdField";
import {IDomainObject} from "core/form/formUtils";
import {observable, ObservableMap} from "mobx";
import {ID} from "core/metamodel/metaConstant";
import {parseId} from "core/common/utils/utils";
import isPlainObject = require("lodash/isPlainObject");

export interface LovItem<T = ID> {
  value: T;
  label: string;
}

export default class MdEntity {


  // entityName
  id: string;

  label: string;

  // objekt (mapa) (fieldName -> MdField)
  @observable private fields: ObservableMap<MdField>;

  lovItems: LovItem<any>[];

  clazzName: string;

  detailRoute: string;

  supportDynamicFields: boolean;

  constructor(json: any) {
    this.fromJson(json);
  }

  protected fromJson(json: any): void {
    for(let key in json) {
      if (json.hasOwnProperty(key)) {
        this[key] = json[key];
      }
    }

    let mapa = observable.shallowMap<MdField>();
    if (isPlainObject(this.fields)) {
      for(let key in this.fields) {
        mapa.set(key, new MdField(this.fields[key], this));
      }
    }
    this.fields = mapa;

  }


  /**
   * vrati LovItem dle zadaneho id (value)
   */
  getLovItem<T = ID>(id: T, strictEquality: boolean = true): LovItem<T> {
    return (strictEquality) ? this.lovItems.find(lov => lov.value === id) : this.lovItems.find(lov => lov.value == id) ;
  }

  getLovItemLabel(id: string|number|boolean) {
    let lov = this.getLovItem(id);
    return (lov) ? lov.label : undefined;
  }

  getLovItemParam(id: string|number|boolean, paramName: string): any {
    let lov = this.getLovItem(id);
    return (lov) ? lov[paramName] : undefined;
  }


  getField(fieldName: string) {
    return this.fields.get(fieldName);
  }

  getFieldByKey(fieldKey: string) {
    let fieldName = (fieldKey) ? parseId(fieldKey).slice(-1).pop() : undefined;
    return (fieldName) ? this.fields.get(fieldName) : undefined;
  }

  getFields(): MdField[] {
    return this.fields.values();
  }

  getDynamicFields(): MdField[] {
    return this.fields.values().filter(md => md.fieldType === FIELDTYPE.DYNAMIC);
  }

  newObject<D extends IDomainObject>(dataObject: D): D {
    if (!dataObject['@class']) dataObject['@class'] = this.clazzName;
    return dataObject;
  }



}






// WEBPACK FOOTER //
// ./src/core/metamodel/mdEntity.ts